import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { DesignShowcaseView } from "./DesignShowcaseView";
import { DesignShowcaseViewStore } from "../../store/DesignShowcaseViewStore";
import { useStore } from "../../../../hooks";

export const DesignShowcaseViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/designShowcase/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new DesignShowcaseViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "identification",
              label: rootStore.langStore.groupDesignShowcaseIdentificationLabel,
            },
            {
              id: "classification",
              label: rootStore.langStore.groupDesignShowcaseClassificationLabel,
            },
            {
              id: "numbers",
              label: rootStore.langStore.groupDesignShowcaseNumbersLabel,
            },
            {
              id: "dates",
              label: rootStore.langStore.groupDesignShowcaseDatesLabel,
            },
            {
              id: "flags",
              label: rootStore.langStore.groupDesignShowcaseFlagsLabel,
            },
            {
              id: "contact",
              label: rootStore.langStore.groupDesignShowcaseContactLabel,
            },
            {
              id: "documents",
              label: rootStore.langStore.groupDesignShowcaseDocumentsLabel,
            },
            {
              id: "richContent",
              label: rootStore.langStore.groupDesignShowcaseRichContentLabel,
            },
            {
              id: "advanced",
              label: rootStore.langStore.groupDesignShowcaseAdvancedLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <DesignShowcaseView designShowcaseViewStore={store} />
      </PageLayout>
    </div>
  );
});
